export { default } from './Pricing'



// WEBPACK FOOTER //
// ./src/App/Pricing/index.js